import { Yup } from "components/DynamicForm/utils";
import { DYNAMIC_TYPE_INPUT_TYPE, HIDDEN_INPUT_TYPE, RADIO_INPUT_TYPE, SELECT_INPUT_TYPE } from "utils/Constants";
import DynamicFormOptions from "utils/DynamicFormOptions";
import { PRODUCT_TAXES } from "utils/ProductTaxes";

const form = {
    "trackingKey": "Calculator",
    sections: [{
        fields: [
            [
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "tax",
                    "validation": Yup.string().required(),
                    "label": "Producto",
                    "description": "Seleccione el tipo de producto que desea traer desde Estados Unidos",
                    "options": PRODUCT_TAXES
                },
                {
                    "type": HIDDEN_INPUT_TYPE,
                    "name": "taxLabel",
                    "label": "Producto",
                    "trackValue": true
                },
            ],
            [
                {
                    "type": "money",
                    "name": "cost",
                    "validation": Yup.number().required().positive(),
                    "description": "Precio del producto incluyendo el costo del envio y los impuestos hasta Miami ",
                    "label": "Precio",
                    "isDecimal": true,
                    "placeholder": "0,00",
                    "step": ".01",
                    "sizing": {
                        "sm": 6
                    }
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "validation": Yup.string().required(),
                    "dynamicType": "number",
                    "name": "weigth",
                    "min": "0",
                    "step": ".01",
                    "label": "Peso",
                    "trackValue": true,
                    "placeholder": "0",
                    "description": "Peso del producto en Libras o Kg",
                    "sizing": {
                        "sm": 6
                    },
                    "options": {
                        "lb": "Lbs",
                        "kg": "Kg",
                    },
                    "defaultOption": "kg"
                },
            ],
            [{
                "type": HIDDEN_INPUT_TYPE,
                "name": "priceType",
                "label": "Tipo de Precio",
                "description": "Selecione el tipo de precio",
                "validation": Yup.string().required(),
                "optionsFunction": DynamicFormOptions.userPriceList,
                "sizing": {
                    "sm": 8
                }
            }]
            // [
            //     {
            //         "type": "checkbox",
            //         "name": "exempt_process_request",
            //         "label": "Solicitar proceso de Exeneracion"
            //     },
            // ] 
        ]
    }]
};


export default form;